import { ERegisterOrAuthByTokenStatus } from '../../../../types/phoneAuth';
import { ERequestStatus } from '../../../../types/requestStatus';
export function selectIsAgreementNextLoading(state) {
  return state.phoneAuth.sendValidationCode.status === ERequestStatus.Loading || state.phoneAuth.registerOrAuthByToken.status === ERegisterOrAuthByTokenStatus.Loading;
}
export function selectAgreement(state) {
  return state.agreement;
}
export function viewDataSelector(state) {
  return state.view.data;
}